import { Config, Service } from "../service/index.js";
//import rowebLogo from "./img/logo/roweb.svg";
import DefaultLogoM from "./img/logo/default.m.png";
import DefaultLogoS from "./img/logo/default.s.png";
export { BrandModel };
class BrandModel {
  /**
   * Название бренда для alt и title к логотипу.
   * @type {string}
   */
  name = "Личная студия";
  /**
   * Адрес домашней страницы личной студии.
   * @type {string}
   */
  home = "/personal-studio";
  /**
   * Текст для `Footer` в формате HTML.
   * @type {string}
   */
  footer =
    `© Электронная информационно-образовательная среда (ЭИОС),<br />
     Цифровой образовательный ресурс «Личная студия», 2014-2024`;
  /**
   * Логотип.
   * @type {string}
   */
  logo = DefaultLogoM;
  /**
   * Маленький логотип.
   * @type {string}
   */
  logo_small = DefaultLogoS;
  /**
   * Устанавливает логотип по vuzId.
   * @param {integer} vuzId - Идентификатор ВУЗа.
   */
  setLogo(vuzId) {
    const url = Config.get("student_service");
    this.logo = `${url}/brand/${vuzId}/logo`;
  }
  /**
   * Загрузка данных бренда.
   * @param {integer} vuzId - Идентификатор ВУЗа.
   * @param {function} [setBrandModel] - Обрабатывает ответ от сервера.
   * @returns {Promise<BrandModel>}
   */
  static async load(vuzId, setBrandModel = null) {
    await Config.load();
    const model = new BrandModel({});
    const url = Config.get("student_service");
    const service = new Service(url);
    model.setLogo(vuzId);
    const response = await service.send(
      {
        method: "get",
        path: `/brand/${vuzId}/footer`,
      });
    if (!response || response.errors)
      console.error("Brand: load", vuzId, "=", response);
    else
      model.footer = response.footer;
    if (setBrandModel) setBrandModel(model);
    return model;
  }
}
